/*=====Images Lazy Load=====*/

function imageLazyLoad(){

    var lazyImages = [].slice.call(document.querySelectorAll("img.lz"));

    lazyImages.forEach(function(lazyImage) {
        var position = lazyImage.getBoundingClientRect();
        if(position.top >= 0 && position.bottom <= (window.innerHeight + 350)) {
            lazyImage.src = (window.innerWidth < 992)? lazyImage.dataset.srcMob : lazyImage.dataset.srcDesctop;
            lazyImage.classList.remove("lz");
        }
    });
}

window.addEventListener('scroll', function() {
    imageLazyLoad();
});

/*======Home History Updte===========*/
window.homeEtherUpdateTimer = 180;
function updateHistory(status) {
    if(document.getElementById("home__history")) {
        status = (status === undefined) ? true : status;

        if (status === "ajaxTimer") {
            var url = (window.location.href.includes("?"))? window.location.href+"&ajax=2": window.location.href+"?ajax=2",
                http = new XMLHttpRequest();
            http.open('GET', url, true);
            http.onreadystatechange = function () {
                if (http.readyState == 4 && http.status == 200) {
                    document.getElementById("home__history").innerHTML = http.response;
                    imageLazyLoad();
                    http.abort();
                }
            };
            http.send();
        } else if (status === true) {
            window.homeEtherUpdate = setInterval(function () {
                if (--window.homeEtherUpdateTimer == 1) {
                    window.clearInterval(window.homeEtherUpdate);
                    window.homeEtherUpdateTimer = 180;
                    var url = (window.location.href.includes("?"))? window.location.href+"&ajax=2": window.location.href+"?ajax=2",
                        http = new XMLHttpRequest();

                    http.open('GET', url, true);
                    http.onreadystatechange = function () {
                        if (http.readyState == 4 && http.status == 200) {
                            document.getElementById("home__history").innerHTML = http.response;
                            imageLazyLoad();
                            updateHistory();
                            http.abort();
                        }
                    };
                    http.send();
                }
            }, 1000);
        } else {
            window.clearInterval(window.homeEtherUpdate);
        }
    }
}
updateHistory();

/*======Search===========*/
function search() {
    if (document.getElementById("search-input")) {
        var search = document.getElementById("search-input");
        search.addEventListener("keyup", function () {
            var value = search.value.toUpperCase(),
                items = Array.from(document.querySelectorAll('.music__item-wrapper'));

            for (var i = 0; i < items.length; i++) {
                var data = items[i].dataset.search;
                if (data.toUpperCase().includes(value)) {
                    items[i].classList.remove("hidden");
                } else {
                    items[i].classList.add("hidden");
                }
            }
        });
    }
}

search();

/*======Header Scroll===========*/
if(window.innerWidth > 992) {
    function headerScroll() {
        var scrolled = window.pageYOffset,
            header = document.getElementById("header"),
            coords = header.clientHeight;

        if (scrolled > coords) {
            header.classList.add("mini");
        }

        window.addEventListener('scroll', function () {
            var scrolled = window.pageYOffset,
                header = document.getElementById("header"),
                coords = header.clientHeight;

            if (scrolled > coords) {
                header.classList.add("mini");
            }
            if (scrolled < coords) {
                header.classList.remove("mini");
            }
        });
    }

    headerScroll();
}
/*======Ether===========*/
window.corectionTimer = 15;
function timer(duration, http, artist){
    window.clearInterval(window.timerId);

    if(artist == false) document.getElementsByClassName("track__time-wrapper")[0].classList.add("hidden");
    else document.getElementsByClassName("track__time-wrapper")[0].classList.remove("hidden");

    var timer = duration, minutes, seconds;

    window.timerId = setInterval(function () {
        minutes = parseInt(timer / 60, 10)
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        minutes = (minutes == minutes) ? minutes : "--";
        seconds = (seconds == seconds) ? seconds : "--";

        document.getElementById("song__time").textContent = minutes + ":" + seconds;

        if(--window.corectionTimer == 0){
            http.abort();
            ajaxRequestTimer('corection');
        }else if(window.corectionTimer < 0){
            window.corectionTimer = 15;
        }

        if (--timer < 0) {
            window.clearInterval(window.timerId);
            ajaxRequestTimer();
            http.abort();
        }
    }, 1000);
}

function ajaxRequestTimer(radioData) {
    if(radioData === 'corection') {
        var url = document.getElementById("header__info-bar").dataset.url+"?ajax=1&rand=" + Math.random(),
            http = new XMLHttpRequest(),
            channel_id = document.getElementById("header__info-bar").dataset.channel_id;
        http.open('GET', url, true);
        http.onreadystatechange = function () {
            if (http.readyState == 4 && http.status == 200) {
                var json = JSON.parse(http.response);
                json = json[channel_id];
                if (json.artist === document.getElementById("radio__curr-artist").innerHTML) {
                    http.abort();
                } else {
                    ajaxRequestTimer();
                    http.abort();
                }
            }
        }
        http.send();
        return false;
    }

    radioData = (radioData == undefined)? true: radioData;
    var http = new XMLHttpRequest(),
        url = document.getElementById("header__info-bar").dataset.url + "?ajax=1&rand=" + Math.random(),
        radio = document.getElementById("radio-fm"),
        hitfm = document.getElementsByClassName("radio__dropdown")[0],
        channel_id = document.getElementById("header__info-bar").dataset.channel_id;
    if(hitfm.dataset.radio == 1 || true){
        if(radio.paused === false || radioData === false) {
            http.open('GET', url, true);
            http.onreadystatechange = function () {
                if (http.readyState == 4 && http.status == 200) {
                    var json = JSON.parse(http.response),
                        date = new Date;
                    json = json[channel_id];
                    var curr = json.current_time.split(":"),
                        end = json.end.split(":"),
                        duration = (date.setHours(end[0], end[1], end[2], 0) - date.setHours(curr[0], curr[1], curr[2], 0)) / 1000;

                    if(json.artist == ""){
                        //document.getElementById("radio__curr-artist").textContent = hitfm.dataset.title;
                        document.getElementById("radio__curr-song").textContent = hitfm.dataset.description;

                        if ('mediaSession' in navigator) {
                            navigator.mediaSession.metadata = new MediaMetadata({
                                title: hitfm.dataset.description,
                                artist: hitfm.dataset.title,
                                artwork: [
                                    //{ src: document.getElementById("radio-logo").getAttribute("src"),   sizes: '96x96',   type: 'image/png' },
                                ]

                            });
                        }

                        timer(59, http, false);
                    }else {
                        document.getElementById("radio__curr-artist").textContent = json.channel[window.lang];
                        document.getElementById("radio__curr-song").textContent = json.artist + ' - ' + json.song;
                        duration = (parseInt(duration) < parseInt(json.duration)) ? parseInt(duration) : parseInt(json.duration);

                        if ('mediaSession' in navigator) {
                            navigator.mediaSession.metadata = new MediaMetadata({
                                title: json.song,
                                artist: json.artist,
                                artwork: [
                                    //{ src: document.getElementById("radio-logo").getAttribute("src"),   sizes: '96x96',   type: 'image/png' },
                                ]

                            });
                        }

                        updateHistory("ajaxTimer");
                        timer(duration, http, json.artist);
                    }
                }else{
                    timer(59, http, false);
                }
            }
            http.send();
        }else{
            window.clearInterval(window.timerId);
            document.getElementById("song__time").textContent = "--:--";
            document.getElementById("radio__curr-artist").textContent = document.getElementsByClassName("radio__dropdown")[0].dataset.title;
            document.getElementById("radio__curr-song").textContent = document.getElementById("radio__curr-song").dataset.default;
        }
    }else{
        window.clearInterval(window.timerId);
        document.getElementById("song__time").textContent = "--:--";
    }
    return false;
}

/*======Calendar===========*/
window.AjaxRequest = 0;
var calendar = {
    date: new Date,
    imgPath: "/app/img/",
    timeHoure: false,
    windowWidth: window.innerWidth,
    days: (window.lang === "ru")? ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"] : ["Lu", "Ma", "Mi", "Jo", "Vi", "Si", "Du"],
    months: (window.lang === "ru")? ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"] : ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Noi", "Dec"],
    fullMonths: (window.lang === "ru")? ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"] : ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"],
    dateId: document.getElementById("json"),
    dates: {},
    dateArr: [],
    activeDate: (document.getElementById("json"))? document.getElementById("json").dataset.ative_date:'',
    datesLenght: (window.innerWidth < 993) ? 4 : 15,
    mY: {mydates: []},
    init: function (calendar) {
        if(document.getElementById("json")){
            var getDates = document.getElementById("json").dataset.json;
            this.dates = JSON.parse(getDates);
        }

        for (var i = 0; i < this.dates.length; i++) {
            var date = new Date(this.dates[i].date);
            this.dateArr.push(date.setHours(0, 0, 0, 0).toString());

            if(this.mY.mydates[date.getFullYear()] === undefined){
                this.mY.mydates[date.getFullYear()] = [];
            }

            if(!this.mY.mydates[date.getFullYear()].includes(date.getMonth())){
                this.mY.mydates[date.getFullYear()].push(date.getMonth());
            }
        }

        if(this.mY.mydates[this.date.getFullYear()] === undefined){
            this.mY.mydates[this.date.getFullYear()] = [];
        }

        if(calendar.pagination.classList.contains("happy")){
            this.datesLenght = (window.innerWidth < 993) ? 5 : 16;
        }else{
            this.datesLenght = (window.innerWidth < 993) ? 4 : 15;
        }

        this.options = calendar, this.createPaginationDates(this.dates), this.createListeners(), this.month = this.date.getMonth();
    },
    filter: function () {
        var h = document.getElementsByClassName("datapicker__pagination-num")[0],
            m = document.getElementsByClassName("datapicker__pagination-num")[1],
            mS = document.getElementsByClassName("datapicker__pagination-num-s")[0],
            videos = document.getElementsByClassName("music__item-wrapper");
        for(var i = 0;i < videos.length;i++){
            var time = videos[i].dataset.time, time = time.split(":");

            if(parseInt(time[0]) == parseInt(h.textContent) && m.textContent == "--"){
                videos[i].classList.remove("hidden");
            }else if(parseInt(time[1]) >= parseInt(m.textContent) && parseInt(time[1]) <= parseInt(mS.textContent) && parseInt(time[0]) == parseInt(h.textContent)){
                videos[i].classList.remove("hidden");
            }else if(parseInt(time[1]) >= parseInt(m.textContent) && parseInt(time[1]) <= parseInt(mS.textContent) && h.textContent == "--"){
                videos[i].classList.remove("hidden");
            }else if(m.textContent == "--" && h.textContent == "--"){
                videos[i].classList.remove("hidden");
            }else{
                videos[i].classList.add("hidden");
            }
        }
    },
    createListeners: function () {
        var pagination = this;

        this.options.pagination.addEventListener("click", function (e) {
            e.preventDefault();
            var el = e.target;
            if(el.classList.contains("datapicker__pagination-item-all") || el.parentElement.classList.contains("datapicker__pagination-item-all") || el.parentElement.parentElement.classList.contains("datapicker__pagination-item-all")){
                var lastEl = document.getElementById("datapicker__pagination-last-item"),
                    currentCalendar = document.getElementById("datapicker__clendar-item"),
                    index = null;

                if(currentCalendar.nextElementSibling.classList.contains("prev")) index = currentCalendar.previousElementSibling.children[0].dataset.date;
                else if(currentCalendar.previousElementSibling.classList.contains("next")) index = currentCalendar.nextElementSibling.children[0].dataset.date;
                else index = currentCalendar.previousElementSibling.children[0].dataset.date;


                pagination.createPaginationElement(new Date(pagination.dates[parseInt(index) - 1].date), parseInt(index) - 1, currentCalendar.nextElementSibling);
                lastEl.classList.add("hidden");
                currentCalendar.remove();


                var elements = document.getElementsByClassName("datapicker__pagination-item"),
                    elem;
                while(elements.length){
                    elem = elements.item(1);
                    if(elem.classList.contains("prev")){
                        break;
                    }else{
                        elem.parentNode.removeChild(elem);
                    }
                }

                pagination.activeDate = "";
                pagination.createPaginationDates(pagination.dates);
                document.getElementById("datapicker__pagination-first-item").classList.remove("hidden");
                pagination.ajaxCall();
            }else if(pagination.timeHoure && el.classList.contains("datapicker__pagination-plus") && el.parentElement.classList.contains("datapicker__pagination-calendar-h")){
                var elData = el.previousElementSibling,
                    int = (elData.textContent == "--")? -1:parseInt(elData.textContent);

                int = int + 1;

                if(int > 23) elData.textContent = "--";
                else if(int < 10) elData.textContent = "0"+int;
                else elData.textContent = int;

                pagination.filter();
            }else if(pagination.timeHoure && el.classList.contains("datapicker__pagination-minus") && el.parentElement.classList.contains("datapicker__pagination-calendar-m")){
                var elData = el.nextElementSibling,
                    int = (elData.textContent == "--")? 59:parseInt(elData.textContent);

                if(int == 59){
                    elData.textContent = int - 9;
                    elData.nextElementSibling.textContent = int;
                }else if(int == 0){
                    elData.textContent = "--";
                    elData.nextElementSibling.textContent = "--";
                }else{
                    elData.textContent = int - 10;
                    elData.nextElementSibling.textContent = int;
                }

                pagination.filter();
            }else if(pagination.timeHoure && e.target.classList.contains("datapicker__pagination-minus") && e.target.parentElement.classList.contains("datapicker__pagination-calendar-h")){
                var elData = el.nextElementSibling,
                    int = (elData.textContent == "--")? 24:parseInt(elData.textContent);

                int = int - 1;

                if(int < 0) elData.textContent = "--";
                else if(int < 10) elData.textContent = "0"+int;
                else elData.textContent = int;

                pagination.filter();
            }else if(pagination.timeHoure && e.target.classList.contains("datapicker__pagination-plus") && e.target.parentElement.classList.contains("datapicker__pagination-calendar-m")){
                var elData = el.previousElementSibling,
                    int = (elData.textContent == "--")? -1:parseInt(elData.textContent);

                if(int + 10 == 60){
                    elData.textContent = int + 9;
                    elData.previousElementSibling.textContent = int;
                }else if(int == 59){
                    elData.textContent = "--";
                    elData.previousElementSibling.textContent = "--";
                }else if(int == -1){
                    elData.textContent = int + 11;
                    elData.previousElementSibling.textContent = "00";
                }else{
                    elData.textContent = int + 10;
                    elData.previousElementSibling.textContent = int;
                }

                pagination.filter();
            }else{
                if(e.target.parentElement.classList.contains("datapicker__pagination-item-link")) {
                    pagination.listenerFirstType(e.target.parentElement.dataset.date, e.target.closest(".datapicker__pagination-item"));
                }else if(e.target.classList.contains("calendar__btn")){
                    pagination.currDate = (e.target.dataset.currDate == undefined)? new Date('December 17, 1995 03:24:00'):new Date(e.target.dataset.currDate);
                    pagination.date = (e.target.dataset.currDate == undefined)? new Date:new Date(e.target.dataset.currDate);
                    pagination.createCalendar();

                    if(pagination.mY.mydates[pagination.date.getFullYear()].includes(pagination.date.getMonth() + 1)) {
                        document.getElementsByClassName("month__next")[0].classList.remove("error");
                    }else{
                        document.getElementsByClassName("month__next")[0].classList.add("error");
                    }
                    if(pagination.mY.mydates[pagination.date.getFullYear()].includes(pagination.date.getMonth() - 1)) {
                        document.getElementsByClassName("month__previos")[0].classList.remove("error");
                    }else{
                        document.getElementsByClassName("month__previos")[0].classList.add("error");
                    }
                }
            }
        }),document.getElementById("datapicker__pagination-slide-next").addEventListener("click", function () {
            var firstEl = document.getElementById("datapicker__pagination-first-item"),
                lastEl = document.getElementById("datapicker__pagination-last-item"),
                currentCalendar = document.getElementById("datapicker__clendar-item");

            if(document.getElementById("datapicker__clendar-item").classList.contains("happy")){
                var index = currentCalendar.previousElementSibling.previousElementSibling.children[0].dataset.date;

                currentCalendar.remove();
                pagination.returnPaginationVideoAll();
                pagination.createPaginationCalendar(new Date(pagination.dates[index].date),
                    lastEl.previousElementSibling.previousElementSibling);

                lastEl.classList.remove("hidden");
                pagination.ajaxCall(index);
            }else if(currentCalendar.nextElementSibling.classList.contains("prev")){
                var index = currentCalendar.previousElementSibling.children[0].dataset.date;
                pagination.createPaginationElement(new Date(pagination.dates[parseInt(index) - 1].date), parseInt(index) - 1, lastEl);
                currentCalendar.remove();
                pagination.createPaginationCalendar(new Date(pagination.dates[index].date), lastEl.previousElementSibling.previousElementSibling);
                lastEl.classList.remove("hidden");
                pagination.ajaxCall(index);
            }else if(currentCalendar.nextElementSibling.nextElementSibling.classList.contains("prev")){
                var index = currentCalendar.nextElementSibling.children[0].dataset.date,
                    secondIndex = firstEl.nextElementSibling.children[0].dataset.date;
                if(pagination.dates[parseInt(secondIndex) + 1] == undefined) {
                    firstEl.classList.add("hidden");
                }else{
                    pagination.createPaginationElement(new Date(pagination.dates[parseInt(index) + 1].date), parseInt(index) + 1, lastEl);
                    currentCalendar.remove();
                    pagination.createPaginationCalendar(new Date(pagination.dates[parseInt(index) + 2].date), lastEl.previousElementSibling.previousElementSibling);
                    lastEl.previousElementSibling.previousElementSibling.previousElementSibling.remove();
                    pagination.createPaginationElement(new Date(pagination.dates[parseInt(secondIndex) + 1].date), parseInt(secondIndex) + 1, firstEl.nextElementSibling);
                    pagination.ajaxCall(parseInt(index) + 2);
                }
            }else{
                var index = firstEl.nextElementSibling.children[0].dataset.date;

                if(pagination.dates[parseInt(index) + 1] == undefined){
                    firstEl.classList.add("hidden");
                }else{
                    pagination.createPaginationElement(new Date(pagination.dates[parseInt(index) + 1].date), parseInt(index) + 1, firstEl.nextElementSibling);
                    lastEl.classList.remove("hidden");
                    lastEl.previousElementSibling.remove();
                }

            }
        }),document.getElementById("datapicker__pagination-slide-prev").addEventListener("click", function () {
            var firstEl = document.getElementById("datapicker__pagination-first-item"),
                lastEl = document.getElementById("datapicker__pagination-last-item"),
                currentCalendar = document.getElementById("datapicker__clendar-item");

            if(currentCalendar.previousElementSibling.classList.contains("next")){
                var index = currentCalendar.nextElementSibling.children[0].dataset.date;
                pagination.createPaginationElement(new Date(pagination.dates[parseInt(index) + 1].date), parseInt(index) + 1, firstEl.nextElementSibling);
                currentCalendar.remove();
                pagination.createPaginationCalendar(new Date(pagination.dates[index].date), firstEl.nextElementSibling.nextElementSibling);
                firstEl.classList.remove("hidden");
                pagination.ajaxCall(index);
            }else if(currentCalendar.previousElementSibling.previousElementSibling.classList.contains("next")){
                var index = currentCalendar.previousElementSibling.children[0].dataset.date,
                    secondIndex = lastEl.previousElementSibling.children[0].dataset.date;
                if(pagination.dates[parseInt(secondIndex) - 1] == undefined) {
                    lastEl.classList.add("hidden");
                }else{
                    pagination.createPaginationElement(new Date(pagination.dates[parseInt(index) - 1].date), parseInt(index) - 1, firstEl.nextElementSibling);
                    currentCalendar.remove();
                    pagination.createPaginationCalendar(new Date(pagination.dates[parseInt(index) - 2].date), firstEl.nextElementSibling.nextElementSibling);
                    firstEl.nextElementSibling.nextElementSibling.nextElementSibling.remove();
                    pagination.createPaginationElement(new Date(pagination.dates[parseInt(secondIndex) - 1].date), parseInt(secondIndex) - 1, lastEl);
                    pagination.ajaxCall(parseInt(index) - 2);
                }
            }else{
                var index = lastEl.previousElementSibling.children[0].dataset.date;

                if(pagination.dates[parseInt(index) - 1] == undefined){
                    lastEl.classList.add("hidden");
                }else{
                    pagination.createPaginationElement(new Date(pagination.dates[parseInt(index) - 1].date), parseInt(index) - 1, lastEl);
                    firstEl.classList.remove("hidden");
                    firstEl.nextElementSibling.remove();
                }

            }
        })
    },
    listenerFirstType: function (index, el) {
        var currentCalendar = document.getElementById("datapicker__clendar-item");
        this.returnPaginationDate(currentCalendar);
        currentCalendar.remove();
        this.createPaginationCalendar(new Date(this.dates[index].date), el);
        this.ajaxCall(index);
    },
    createPaginationDates: function(dates){
        if(this.activeDate == "") {
            if(this.options.pagination.classList.contains("happy")){
                this.createPaginationCalendarAll();
                for (var i = 0; i < this.datesLenght; i++) {
                    if (dates[i] == undefined) {
                        document.getElementById("datapicker__pagination-first-item").classList.add("hidden");
                        break;
                    } else {
                        this.createPaginationElement(new Date(dates[i].date), i);
                    }
                }
            }else {
                this.createPaginationCalendar(new Date(dates[0].date));
                for (var i = 1; i < this.datesLenght; i++) {
                    if (dates[i] == undefined) {
                        document.getElementById("datapicker__pagination-first-item").classList.add("hidden");
                        break;
                    } else {
                        this.createPaginationElement(new Date(dates[i].date), i);
                    }
                }
            }
        }else{
            for(var j = 0; j < dates.length; j++) {
                if(new Date(this.activeDate).setHours(0, 0, 0, 0).toString() == new Date(dates[j].date).setHours(0, 0, 0, 0).toString()){
                    var pgLength1 = this.datesLenght + j,
                        pgLength = dates.length - j;

                    if(pgLength < this.datesLenght) {
                        document.getElementById("datapicker__pagination-last-item").classList.remove("hidden");
                        var pgLength2 = this.datesLenght - pgLength,
                            pgLength3 = pgLength1 - pgLength2,
                            pgLength4 = pgLength3 - this.datesLenght,
                            pgLength4 = (pgLength4 < 0)? 0 : pgLength4;

                        for (var i = pgLength4; i < pgLength3; i++) {
                            if (new Date(this.activeDate).setHours(0, 0, 0, 0).toString() == new Date(dates[i].date).setHours(0, 0, 0, 0).toString()) {
                                this.createPaginationCalendar(new Date(this.activeDate));
                            } else {
                                this.createPaginationElement(new Date(dates[i].date), i);
                            }
                        }
                        if (document.getElementById("datapicker__clendar-item").previousElementSibling.classList.contains("next")) {
                            document.getElementById("datapicker__pagination-first-item").classList.add("hidden");
                        }
                    }else{
                        var arrLenght = (j - 1 == -1)? this.datesLenght + j:this.datesLenght + j - 1;
                        for(var i = (j - 1 == -1)? 0:j -1; i < arrLenght; i++) {
                            if(new Date(this.activeDate).setHours(0, 0, 0, 0).toString() == new Date(dates[i].date).setHours(0, 0, 0, 0).toString()){
                                this.createPaginationCalendar(new Date(this.activeDate));
                            }else{
                                this.createPaginationElement(new Date(dates[i].date), i);
                            }
                        }
                        if(j - 1 > 0) document.getElementById("datapicker__pagination-last-item").classList.remove("hidden");
                    }
                }
            }
        }
    },
    createPaginationElement: function (date, index, insertEl) {
        var d = (date.getDay() - 1 < 0) ? 6 : date.getDay() - 1,
            item = document.createElement('li'),
            link = document.createElement('a'),
            month = document.createElement('span'),
            day = document.createElement('span'),
            monthNode = document.createTextNode(this.months[date.getMonth()]),
            dayNode = document.createTextNode(this.days[d] + " " + date.getDate());

        item.className = "datapicker__pagination-item", item.setAttribute("data-date-li", date.setHours(0, 0, 0, 0).toString());
        link.className = "datapicker__pagination-item-link";
        link.setAttribute("data-date", index);
        month.appendChild(monthNode);
        day.appendChild(dayNode);
        link.appendChild(month);
        link.appendChild(day);

        item.appendChild(link);
        if(insertEl === undefined) {
            this.options.pagination.insertBefore(item, this.options.pagination.children[1]);
        }else{
            this.options.pagination.insertBefore(item, insertEl);
        }
    },
    createPaginationCalendar: function(date, insertEl){
        var days = (window.lang === "ru")? ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"] : ["Luni", "Marţi", "Miercuri", "Joi", "Vineri", "Sâmbătă", "Duminică"],
            d = (date.getDay() - 1 < 0) ? 6 : date.getDay() - 1,
            li = document.createElement('li'),
            calendar = document.createElement('div'),
            calendarDate = document.createElement('div'),
            day = document.createElement('span'),
            br = document.createElement('br'),
            fullDate = document.createElement('span'),
            imgItem = document.createElement('span'),
            img = document.createElement("img");

        li.setAttribute("id", "datapicker__clendar-item"), li.classList.add("datapicker__pagination-item"), li.classList.add("datapicker__clendar-item"), li.setAttribute("data-date-li-c", date.setHours(0, 0, 0, 0).toString());

        calendar.classList.add("datapicker__pagination-calendar");

        if(document.getElementById("dataPickerPagination").classList.contains("pagination__h-m")){
            this.timeHoure = true;
            var h_m = document.createElement('div'),
                h = document.createElement('span'),
                h_plus = document.createElement('span'),
                h_minus = document.createElement('span'),
                h_num = document.createElement('span'),
                m = document.createElement('span'),
                m_plus = document.createElement('span'),
                m_minus = document.createElement('span'),
                m_num = document.createElement('span'),
                m_num_s = document.createElement('span');

            h_m.classList.add("datapicker__pagination-calendar-h-m");
            h.classList.add("datapicker__pagination-calendar-h");
            h_plus.classList.add("datapicker__pagination-plus");
            h_num.classList.add("datapicker__pagination-num"), h_num.textContent = "--";
            h_minus.classList.add("datapicker__pagination-minus");
            h.appendChild(h_minus), h.appendChild(h_num), h.appendChild(h_plus);

            m.classList.add("datapicker__pagination-calendar-m");
            m_plus.classList.add("datapicker__pagination-plus");
            m_num.classList.add("datapicker__pagination-num"), m_num.textContent = "--";
            m_num_s.classList.add("datapicker__pagination-num-s"), m_num_s.textContent = "--";
            m_minus.classList.add("datapicker__pagination-minus");
            m.appendChild(m_minus), m.appendChild(m_num), m.appendChild(m_num_s), m.appendChild(m_plus);

            h_m.appendChild(h), h_m.appendChild(m);
        }else{
            this.timeHoure = false;
        }

        calendarDate.classList.add("datapicker__pagination-calendar-date");
        day.setAttribute("id", "date_day");
        day.innerHTML = days[d];

        fullDate.innerHTML = date.getFullYear() + " " + this.fullMonths[date.getMonth()] + " " + date.getDate();

        calendarDate.appendChild(day);
        calendarDate.appendChild(br);
        calendarDate.appendChild(fullDate);

        imgItem.classList.add("datapicker__pagination-calendar-svg");
        img.setAttribute("src", this.imgPath+"dataCalendar.svg"), img.classList.add("calendar__btn"), img.setAttribute("id", "calendar__btn"), img.setAttribute("data-curr-date", date);
        imgItem.appendChild(img);

        if(this.timeHoure) calendar.appendChild(h_m);
        calendar.appendChild(calendarDate), calendar.appendChild(imgItem);
        li.appendChild(calendar);
        if(insertEl === undefined) {
            this.options.pagination.insertBefore(li, this.options.pagination.children[1]);
        }else{
            this.options.pagination.insertBefore(li, insertEl);
            insertEl.remove();
        }
    },
    createPaginationCalendarAll: function(){
        var insertEl = (document.getElementById("all-videos"))? document.getElementById("all-videos"):document.getElementById("datapicker__clendar-item"),
            li = document.createElement('li'),
            calendar = document.createElement('div'),
            calendarDate = document.createElement('div'),
            day = document.createElement('span'),
            br = document.createElement('br'),
            fullDate = document.createElement('span'),
            imgItem = document.createElement('span'),
            img = document.createElement("img");

        li.setAttribute("id", "datapicker__clendar-item"), li.classList.add("datapicker__pagination-item"),
            li.classList.add("datapicker__clendar-item"),li.classList.add("happy");

        calendar.classList.add("datapicker__pagination-calendar");
        calendarDate.classList.add("datapicker__pagination-calendar-date");
        day.setAttribute("id", "date_day");
        var text = this.options.pagination.dataset.allText,
            text = text.split(",");

        day.innerHTML = text[0];

        fullDate.innerHTML = text[1];

        calendarDate.appendChild(day);
        calendarDate.appendChild(br);
        calendarDate.appendChild(fullDate);

        imgItem.classList.add("datapicker__pagination-calendar-svg");
        img.setAttribute("src", this.imgPath+"dataCalendar.svg"), img.classList.add("calendar__btn"), img.setAttribute("id", "calendar__btn");
        imgItem.appendChild(img);

        calendar.appendChild(calendarDate), calendar.appendChild(imgItem);
        li.appendChild(calendar);
        this.options.pagination.insertBefore(li, insertEl);
        insertEl.remove();
    },
    returnPaginationVideoAll: function(){
        var item = document.createElement('li'),
            link = document.createElement('a'),
            textPart = document.createElement('span'),
            secondTextPart = document.createElement('span'),
            text = this.options.pagination.dataset.allText,
            text = text.split(","),
            href = this.options.pagination.dataset.link;

        item.className = "datapicker__pagination-item-all",
            item.setAttribute("id", "all-videos");
        link.setAttribute("href", href);
        textPart.appendChild(document.createTextNode(text[0]));
        secondTextPart.appendChild(document.createTextNode(text[1]));
        link.appendChild(textPart);
        link.appendChild(secondTextPart);

        item.appendChild(link);
        this.options.pagination.appendChild(item);
    },
    returnPaginationDate: function (el) {
        if(el.classList.contains("happy")){
            this.returnPaginationVideoAll();
        }else if(el.nextElementSibling.classList.contains("prev")){
            var index = el.previousElementSibling.children[0].dataset.date;
            this.createPaginationElement(new Date(this.dates[parseInt(index) - 1].date), parseInt(index) - 1, el.nextElementSibling);
        }else{
            var index = el.nextElementSibling.children[0].dataset.date;
            this.createPaginationElement(new Date(this.dates[parseInt(index) + 1].date), parseInt(index) + 1, el.nextElementSibling);
        }
    },
    returnPaginationCalendar: function (index, currentCalendar) {
        if(this.dates[(index - 1)] == undefined){
            this.createPaginationCalendarAll();
            currentCalendar.remove();
        }else {
            this.createPaginationCalendar(new Date(this.dates[index - 1].date), currentCalendar);
            currentCalendar.remove();
        }
    },
    ajaxCall: function (index) {
        if(index == undefined) {
            document.getElementById("ajax__preloader").classList.add("active");
            document.getElementById("video__wrapper").innerHTML = "";
            var url = this.options.pagination.dataset.link,
                http = new XMLHttpRequest(),
                sendUrl = (window.innerWidth < 993) ? url + "?ajax=2&platform=m" : url + "?ajax=2&platform=d";

            http.open('GET', sendUrl, true);
            http.onreadystatechange = function () {
                if (http.readyState == 4 && http.status == 200) {
                    document.getElementById("video__wrapper").innerHTML = http.response;
                    document.getElementById("ajax__preloader").classList.remove("active");
                    window.history.pushState({url: url}, '', url);
                    var lazyImages = [].slice.call(document.querySelectorAll("img.lz"));
                    lazyImages.forEach(function (lazyImage) {
                        lazyImage.src = (window.innerWidth < 992) ? lazyImage.dataset.srcMob : lazyImage.dataset.srcDesctop;
                        lazyImage.classList.remove("lz");
                    });
                    video.init();
                }
            }
            http.send();
        }else{
            document.getElementById("ajax__preloader").classList.add("active");
            document.getElementById("video__wrapper").innerHTML = "";
            var url = window.location.href,
                date = this.dates[index].date,
                dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/,
                isMatch = dateType.test(url);

            url = url.split("/");
            if (isMatch) {
                var urlLast = url.pop();
            }

            url = url.join('/') + "/" + date;

            window.AjaxRequest = window.AjaxRequest + 1;
            setTimeout(function () {
                if (window.AjaxRequest == 1) {
                    var http = new XMLHttpRequest(),
                        sendUrl = (window.innerWidth < 993) ? url + "?ajax=2&platform=m" : url + "?ajax=2&platform=d";

                    http.open('GET', sendUrl, true);
                    http.onreadystatechange = function () {
                        if (http.readyState == 4 && http.status == 200) {
                            document.getElementById("video__wrapper").innerHTML = http.response;
                            document.getElementById("ajax__preloader").classList.remove("active");
                            window.history.pushState({url: url}, '', url);
                            var lazyImages = [].slice.call(document.querySelectorAll("img.lz"));
                            lazyImages.forEach(function (lazyImage) {
                                lazyImage.src = (window.innerWidth < 992) ? lazyImage.dataset.srcMob : lazyImage.dataset.srcDesctop;
                                lazyImage.classList.remove("lz");
                            });
                            video.init();
                        }
                    }
                    http.send();
                }
                window.AjaxRequest = window.AjaxRequest - 1;
            }, 500);
        }
    },
    calendarListeners: function () {
        var calendar = this;
        this.next.addEventListener("click", function () {
            if(calendar.mY.mydates[calendar.date.getFullYear()].includes(calendar.date.getMonth() + 2)) {
                document.getElementsByClassName("month__next")[0].classList.remove("error");
            }else{
                document.getElementsByClassName("month__next")[0].classList.add("error");
                document.getElementsByClassName("month__previos")[0].classList.remove("error");
            }

            if(calendar.mY.mydates[calendar.date.getFullYear()].includes(calendar.date.getMonth() + 1)) {
                calendar.date = new Date(calendar.date.setMonth(calendar.date.getMonth() + 1));
                calendar.clearCalendar();
                document.getElementById("vcal-header__label").innerHTML = calendar.fullMonths[calendar.date.getMonth()] + " " + calendar.date.getFullYear();
            }else if((calendar.date.getMonth() + 1) > 11){
                var year = parseInt(calendar.date.getFullYear()) + 1;
                calendar.date = new Date(calendar.date.setFullYear(year, calendar.mY.mydates[year][calendar.mY.mydates[year].length - 1]));
                calendar.clearCalendar();
                document.getElementById("vcal-header__label").innerHTML = calendar.fullMonths[calendar.mY.mydates[year][calendar.mY.mydates[year].length - 1]] + " " + year;
            }
        }), this.previous.addEventListener("click", function () {
            if(calendar.mY.mydates[calendar.date.getFullYear()].includes(calendar.date.getMonth() - 2)) {
                document.getElementsByClassName("month__previos")[0].classList.remove("error");
            }else{
                document.getElementsByClassName("month__previos")[0].classList.add("error");
                document.getElementsByClassName("month__next")[0].classList.remove("error");
            }

            if(calendar.mY.mydates[calendar.date.getFullYear()].includes(calendar.date.getMonth() - 1)) {
                calendar.date = new Date(calendar.date.setMonth(calendar.date.getMonth() - 1));
                calendar.clearCalendar();
                document.getElementById("vcal-header__label").innerHTML = calendar.fullMonths[calendar.date.getMonth()] + " " + calendar.date.getFullYear();
            }else if((calendar.date.getMonth() - 1) < 0){
                var year = parseInt(calendar.date.getFullYear()) - 1;

                calendar.date = new Date(calendar.date.setFullYear(year, calendar.mY.mydates[year][0]));
                calendar.clearCalendar();
                document.getElementById("vcal-header__label").innerHTML = calendar.fullMonths[calendar.mY.mydates[year][0]] + " " + year;
            }
        })
    },
    dateClicked: function () {
        var pagination = this,
            firstEl = document.getElementById("datapicker__pagination-first-item"),
            lastEl = document.getElementById("datapicker__pagination-last-item"),
            activeDates = document.querySelectorAll(".vcal-date--active"),
            elements = document.querySelectorAll(".datapicker__pagination-item"),
            elementsArr = new Array;

        for(var j = 0; j < elements.length; j++) elementsArr.push(elements[j].dataset.dateLi);

        for (var i = 0; i < activeDates.length; i++){
            activeDates[i].addEventListener("click", function (e) {
                var index = pagination.dateArr.indexOf(e.target.closest(".vcal-date--active").dataset.calendarDate);

                if(elementsArr.includes(e.target.closest(".vcal-date--active").dataset.calendarDate)){
                    var currentEl = document.querySelectorAll('[data-date-li="'+e.target.closest(".vcal-date--active").dataset.calendarDate+'"]')[0];
                    pagination.listenerFirstType(currentEl.children[0].dataset.date, currentEl);

                    var currentCalendar = document.getElementById("datapicker__clendar-item");
                    if(currentCalendar.previousElementSibling.classList.contains("next")){
                        var indexEL = currentCalendar.nextElementSibling.children[0].dataset.date;
                        pagination.createPaginationElement(new Date(pagination.dates[parseInt(indexEL) + 1].date), parseInt(indexEL) + 1, firstEl.nextElementSibling);
                        lastEl.previousElementSibling.remove();
                    }else if(currentCalendar.nextElementSibling.classList.contains("prev")){
                        var indexEL = currentCalendar.previousElementSibling.children[0].dataset.date;
                        pagination.createPaginationElement(new Date(pagination.dates[parseInt(indexEL) - 2].date), parseInt(indexEL) - 2, lastEl);
                        firstEl.nextElementSibling.remove();
                    }
                }else{
                    var index = pagination.dateArr.indexOf(e.target.closest(".vcal-date--active").dataset.calendarDate),
                        currentCalendar = document.getElementById("datapicker__clendar-item");

                    if(index == 0){
                        pagination.activeDate = "";
                        var items = document.querySelectorAll(".datapicker__pagination-item");
                        for(i = 0; items.length > i;i++){
                            if(items[i].classList.contains("next") == false && items[i].classList.contains("prev")  == false){
                                items[i].remove();
                            }
                        }
                        pagination.createPaginationDates(pagination.dates);
                        firstEl.classList.remove("hidden");
                        lastEl.classList.add("hidden");
                    }else if(pagination.dateArr.length - index > pagination.datesLenght){
                        for(i = index - 1; index - 1 + pagination.datesLenght > i; i++){
                            pagination.createPaginationElement(new Date(pagination.dates[i].date), i);
                            lastEl.previousElementSibling.remove();
                        }
                        pagination.createPaginationCalendar(new Date(pagination.dates[index].date), document.querySelectorAll('[data-date="'+index+'"]')[0].parentElement);
                        lastEl.classList.remove("hidden");
                        firstEl.classList.remove("hidden");
                    }else{
                        for(i = 0; pagination.dateArr.length - pagination.datesLenght > i; i++){
                            pagination.createPaginationElement(new Date(pagination.dates[pagination.datesLenght + i].date), pagination.datesLenght + i);
                            lastEl.previousElementSibling.remove();
                        }
                        currentCalendar.remove();
                        pagination.createPaginationCalendar(new Date(pagination.dates[index].date), document.querySelectorAll('[data-date="'+index+'"]')[0].parentElement);
                        firstEl.classList.add("hidden");
                        lastEl.classList.remove("hidden");
                        var currentCalendar = document.getElementById("datapicker__clendar-item");
                        if(currentCalendar.nextElementSibling.classList.contains("prev") || currentCalendar.nextElementSibling.nextElementSibling.classList.contains("prev")){
                            var indexEL = currentCalendar.previousElementSibling.children[0].dataset.date;
                            pagination.createPaginationElement(new Date(pagination.dates[parseInt(indexEL) - 2].date), parseInt(indexEL) - 2, lastEl);
                            firstEl.nextElementSibling.remove();
                            firstEl.classList.remove("hidden");
                        }
                    }
                }

                pagination.ajaxCall(index);
            });
        }

        if(document.getElementsByClassName("vcal-header__label")[0]){
            var headerEL = document.getElementsByClassName("vcal-header__label")[0];
            headerEL.addEventListener("click", function (e) {
                var currentCalendar = document.getElementById("datapicker__clendar-item"),
                    index = currentCalendar.previousElementSibling.children[0].dataset.date;

                pagination.returnPaginationCalendar(index, currentCalendar);
            });
        }
    },
    createCalendar: function () {
        var wrapperDiv = document.createElement("div"),
            wrapper = document.createElement("div"),
            calendar = document.createElement("div"),
            header = document.createElement("div"),
            label = document.createElement("div"),
            week = document.createElement("div"),
            body = document.createElement("div");

        calendar.setAttribute("id", "v-cal"), calendar.classList.add("vdp-datepicker");
        header.classList.add("vcal-header");

        var btnPreviousSVG = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        setAttributes(btnPreviousSVG, {"class":"month__previos","width": "15.397", "height": "18.674", "viewBox": "0 0 15.397 18.674"});
        var path = document.createElementNS('http://www.w3.org/2000/svg', "path");
        setAttributes(path, {
            "id": "Path_53",
            "data-name": "Path 53",
            "d": "M508-99l-13,8,13,9",
            "transform": "translate(-493.172 99.852)",
            "fill": "none",
            "stroke": "#fff",
            "stroke-width": "2"
        });
        btnPreviousSVG.appendChild(path);
        this.previous = btnPreviousSVG;
        header.appendChild(btnPreviousSVG);

        label.setAttribute("id", "vcal-header__label"), label.classList.add("vcal-header__label"), label.innerHTML = this.fullMonths[this.date.getMonth()]+" "+this.date.getFullYear();
        header.appendChild(label);

        var btnNextSVG = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        setAttributes(btnNextSVG, {"class":"month__next","width": "15.397", "height": "18.674", "viewBox": "0 0 15.397 18.674"});
        var path2 = document.createElementNS('http://www.w3.org/2000/svg', "path");
        setAttributes(path2, {
            "id": "Path_42",
            "data-name": "Path 42",
            "d": "M13,0,0,8l13,9",
            "transform": "translate(13.569 17.822) rotate(180)",
            "fill": "none",
            "stroke": "#fff",
            "stroke-width": "2"
        });
        btnNextSVG.appendChild(path2);
        this.next = btnNextSVG;
        header.appendChild(btnNextSVG);

        function setAttributes(el, attrs) {
            for (var key in attrs) {
                el.setAttribute(key, attrs[key]);
            }
        }


        calendar.appendChild(header);
        week.classList.add("vcal-week");
        for (i = 0; i < this.days.length; i++) {
            var span = document.createElement("span");
            span.innerHTML = this.days[i];
            week.appendChild(span);
        }
        calendar.appendChild(week);
        body.setAttribute("id", "vcal-body"), body.classList.add("vcal-body"), calendar.appendChild(body);
        this.body = body;
        wrapper.appendChild(calendar);
        wrapper.setAttribute("id", "vdp-wrapper-id"), wrapper.classList.add("vdp-wrapper");

        document.querySelectorAll(".datapicker__pagination-calendar-svg")[0].appendChild(wrapper);

        this.createMonth();
        this.calendarListeners();
    },
    createDay: function (d) {
        var el = document.createElement("div"),
            s = document.createElement("span");

        s.innerHTML = d,
            el.setAttribute("data-calendar-date", new Date(this.date.getFullYear(), this.date.getMonth(), d).setHours(0, 0, 0, 0).toString()),
            el.className = "vcal-date", (new Date(this.date.getFullYear(), this.date.getMonth(), d).setHours(0, 0, 0, 0).toString() == this.currDate.setHours(0, 0, 0, 0).toString())? el.classList.add("vcal-date--selected"):"", (this.dateArr.includes(new Date(this.date.getFullYear(), this.date.getMonth(), d).setHours(0, 0, 0, 0).toString()))? el.classList.add("vcal-date--active"):el.classList.add("vcal-date--disabled"), el.appendChild(s);
        this.body.appendChild(el);
    },
    createMonth: function () {
        for (var i = 1; new Date(this.date.getFullYear(), parseInt(this.date.getMonth()) + 1, 0).getDate() >= i;i++){
            var getDate = new Date(this.date.getFullYear(), parseInt(this.date.getMonth()), i),
                d = (getDate.getDay() - 1 < 0) ? 6 : getDate.getDay() - 1;
            if(d > 0 && i == 1){
                for(j = 0;j<d;j++){
                    this.createDay('');
                }
                this.createDay(i);
            }else{
                this.createDay(i);
            }
        }
        this.dateClicked();
    },
    clearCalendar: function () {
        document.getElementById("vcal-body").innerHTML = "";
        this.createMonth();
    },
}

if(document.getElementById("dataPickerPagination")) {
    calendar.init({
        pagination: document.getElementById("dataPickerPagination")
    });

    var specifiedElement = document.getElementById('dataPickerPagination')
    document.addEventListener("click", function (e) {
        e.stopPropagation();
        if(!e.target.classList.contains("calendar__btn")) {
            var paginationCalendar = document.getElementById("vdp-wrapper-id"),
                isClickInside = specifiedElement.contains(e.target);

            if (!isClickInside && paginationCalendar) {
                var currentCalendar = document.getElementById("datapicker__clendar-item"),
                    index = currentCalendar.previousElementSibling.children[0].dataset.date;

                calendar.returnPaginationCalendar(index, currentCalendar);
            }
        }
    });
}

/*===========VIDEO=============*/
var video = {
    frame: document.getElementById("videoIfrm"),
    init: function(options){
        var ajaxReady = (options == undefined)? false: options.ajax;
        this.options = this.createListeners();
        if(document.getElementById("mobileEl") && window.innerWidth < 993){
            var videoButtons = document.getElementsByClassName("music__item");
            for(var i = 0;i < videoButtons.length;i++){
                videoButtons[i].classList.add("mobile");
            }
        }

        var locationUrl = window.location;

        if(gup("song", locationUrl) !== null){
            this.createFrame(gup("song", locationUrl), document.querySelectorAll('[data-video-id="'+gup("song", locationUrl)+'"]')[0], ajaxReady);
        }

        function gup( name, url ) {
            if (!url) url = location.href;
            name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
            var regexS = "[\\?&]"+name+"=([^&#]*)";
            var regex = new RegExp( regexS );
            var results = regex.exec( url );
            return results == null ? null : results[1];
        }

    },
    createListeners: function (){
        var video = this,
            videoLinks = document.querySelectorAll(".video__link");
        for(var i = 0;i<videoLinks.length;i++){
            var click = 0;
            videoLinks[i].addEventListener("click", function(e){
                e.preventDefault();

                var el = document.getElementById("play-pause"),
                    radio = document.getElementById("radio-fm");
                if (!radio.paused) {
                    radio.pause();
                    radio.setAttribute("src", "#");
                    el.setAttributeNS("http://www.w3.org/1999/xlink", 'xlink:href', '#play');
                }

                click++;
                var id = this.getAttribute("data-video-id"),
                    uniqueId = this.getAttribute("data-unique-video-id");
                if(this.classList.contains("hide__show")){
                    if (click%2==0 && e.target.closest(".video__link").children[0].classList.contains("hidden")) {
                        video.closeShowFrame(uniqueId, id, this, 0);
                    } else {
                        video.closeShowFrame(uniqueId, id, this, 1);
                    }

                }else{
                    video.createFrame(uniqueId, id, this);
                }
            });
        }
    },
    closeShowFrame: function(uniqueId, id, el, num){
        this.removeFrame();
        if(num == 1) {
            var wrapper = document.createElement("div"),
                frame = document.createElement("div");

            frame.setAttribute("id", "videoIfrm");
            frame.classList.add("hit");
            wrapper.classList.add("hit__item-video");
            wrapper.classList.add("slideDown");
            wrapper.appendChild(frame);
            if(el.closest(".hit__item")){
                el.closest(".hit__item").insertBefore(wrapper, el.closest(".hit__item").children[0]);
            }else{
                el.closest(".music__item").insertBefore(wrapper, el.closest(".music__item").children[0]);
            }
            el.children[0].classList.add("hidden");
            el.children[1].classList.remove("hidden");
            this.player(uniqueId, id);
        }else{
            el.children[0].classList.remove("hidden");
            el.children[1].classList.add("hidden");
        }
    },
    createFrame: function(uniqueId, id, el, ready){
        this.removeFrame(0);
        var wrapper = (el.closest(".video__item-thumbnail") == null)? el.closest(".music__item"):el.closest(".video__item-thumbnail"),
            frame = document.createElement("div");

        frame.setAttribute("id", "videoIfrm");
        if(el.nextElementSibling && el.nextElementSibling.classList.contains("music__item-thumbnail")) {
            el.nextElementSibling.appendChild(frame);
        }else{
            wrapper.insertBefore(frame, wrapper.children[1]);
        }

        this.player(uniqueId, id, ready);
    },
    removeFrame: function(t){
        if(document.getElementById("videoIfrm") !== null && t == 0) {
            document.getElementById("videoIfrm").remove();
        }else if(document.getElementById("videoIfrm") !== null){
            var linkWrapper = document.getElementById("videoIfrm").parentElement;
            if(linkWrapper.classList.contains("hit__item-video")){
                if(linkWrapper.nextElementSibling.nextElementSibling.classList.contains("hit__item-play")){
                    var button = linkWrapper.nextElementSibling.nextElementSibling.children[0];
                }else{
                    var button = linkWrapper.nextElementSibling.children[0];
                }

                button.children[0].classList.remove("hidden");
                button.children[1].classList.add("hidden");
                linkWrapper.remove();
            }else{
                var link = document.getElementById("videoIfrm").parentElement.nextElementSibling.children[0].children[0].children[0];
                link.children[0].classList.remove("hidden");
                link.children[1].classList.add("hidden");
                document.getElementById("videoIfrm").parentElement.remove();
            }
        }
    },
    player: function(uniqueId, id, ready){
        if(ready === false){
            window.onYouTubeIframeAPIReady = function() {
                window.player = new window.YT.Player('videoIfrm', {
                    videoId: id,
                    playerVars: {'rel': 0, 'showinfo': 0, 'modestbranding': 1},
                    events: {
                        'onReady': onPlayerReady
                    }
                });
                function onPlayerReady(event) {
                    event.target.playVideo();
                    document.querySelectorAll('[data-unique-video-id="'+uniqueId+'"]')[0].parentNode.parentNode.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            }
        }else{
            window.player = new window.YT.Player('videoIfrm', {
                videoId: id,
                playerVars: {'rel': 0, 'showinfo': 0, 'modestbranding': 1},
                events: {
                    'onReady': onPlayerReady
                }
            });

            function onPlayerReady(event) {
                event.target.playVideo();
                document.querySelectorAll('[data-unique-video-id="'+uniqueId+'"]')[0].parentNode.parentNode.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }
    }
}

video.init();

/*=====================HEADER====================*/
if(document.getElementById("radio__btn-toggle")) {
    if(window.innerWidth < 992) {
        var element = document.getElementById("radio__btn-toggle");
        element.addEventListener("click", function (e) {
            document.getElementById("radio_select").classList.toggle('open');
        });
    }
}

if(document.getElementById("conditats__link")) {
    var condidat = document.getElementById("conditats__link");
    condidat.addEventListener("click", function(e){
        e.preventDefault();
        condidat.classList.toggle('open');
        document.getElementById("condidates").classList.toggle('open');
    });
}

var slider = document.getElementById("volume"),
    radio = document.getElementById("radio-fm");

slider.parentElement.setAttribute("style", "background:rgba(227, 5, 24, 0) linear-gradient(90deg, rgb(227, 5, 24) "+slider.value+"%, rgba(227, 5, 24,.5) "+slider.value+"%) repeat scroll 0% 0%");
radio.volume = (slider.value / 100);
slider.oninput = function() {
    this.parentElement.setAttribute("style", "background:rgba(227, 5, 24, 0) linear-gradient(90deg, rgb(227, 5, 24) "+this.value+"%, rgba(227, 5, 24,.5) "+this.value+"%) repeat scroll 0% 0%");
    radio.volume = (this.value / 100);
    if(this.value == 0){
        document.getElementById("audio-on-off").classList.add("off");
    }else{
        radio.muted = false;
        document.getElementById("audio-on-off").classList.remove("off");
    }
}

function playPause() {
    var el = document.getElementById("play-pause"),
        radio = document.getElementById("radio-fm"),
        fm = document.getElementById('play-pause-btn').dataset.fm;

    if (radio.paused) {
        radio.setAttribute("src", fm);
        radio.play();
        if(document.getElementById("videoIfrm")){
            document.getElementById("videoIfrm").remove();
        }
        el.setAttributeNS("http://www.w3.org/1999/xlink", 'xlink:href', '#play-active');
        updateHistory(false);
    }else {
        radio.pause();
        radio.setAttribute("src", "#");
        el.setAttributeNS("http://www.w3.org/1999/xlink", 'xlink:href', '#play');
        updateHistory();
    }

    ajaxRequestTimer();
}

if ('mediaSession' in navigator) {
    navigator.mediaSession.setActionHandler('pause', function() {
        document.getElementById("play-pause").setAttributeNS("http://www.w3.org/1999/xlink", 'xlink:href', '#play');
        playPause();
    });

    navigator.mediaSession.metadata = new MediaMetadata({
        title: document.getElementsByClassName("radio__dropdown")[0].dataset.title,
        artist: document.getElementsByClassName("radio__dropdown")[0].dataset.description,
        artwork: [
            //{ src: document.getElementById("radio-logo").getAttribute("src"),   sizes: '96x96',   type: 'image/png' },
        ]

    });
}


function muted() {
    var el = document.getElementById("audio-on-off"),
        slider = document.getElementById("volume"),
        radio = document.getElementById("radio-fm");
    if (radio.muted) {
        radio.muted = false;
        el.classList.remove("off");
        slider.value = slider.dataset.val;
        slider.parentElement.setAttribute("style", "background:rgba(227, 5, 24, 0) linear-gradient(90deg, rgb(227, 5, 24) "+slider.dataset.val+"%, rgba(227, 5, 24,.5) "+slider.dataset.val+"%) repeat scroll 0% 0%");
    }else {
        radio.muted = true;
        el.classList.add("off");
        slider.dataset.val = slider.value;
        slider.value = 0;
        slider.parentElement.setAttribute("style", "background:rgba(227, 5, 24, 0) linear-gradient(90deg, rgb(227, 5, 24) 0%, rgba(227, 5, 24,.5) 0%) repeat scroll 0% 0%");
    }
}

var radioItems = document.querySelectorAll(".radio__dropdown-item-link"),
    radio = document.getElementById("radio-fm");

for(var i = 0; i < radioItems.length; i++){
    radioItems[i].addEventListener("click", function(e){
        e.preventDefault();
        var radio = document.getElementById("radio-fm"),
            href = this.getAttribute("href"),
            img = this.children[0],
            title = this.dataset.title,
            desc = this.dataset.description;
            id = this.dataset.id;

        document.getElementById("play-pause-btn").classList.add("loading");
        document.getElementById("play-pause-loading").classList.add("loading");
        document.getElementById("play-pause-btn").setAttribute("data-fm", href);
        //document.getElementById("radio-logo").setAttribute("src", img.getAttribute("src"));
        document.getElementsByClassName("radio__dropdown")[0].setAttribute("data-radio", this.dataset.radio); 

        /*if(radio.paused) {
            radio.setAttribute("src", href);
            document.getElementById("radio__curr-artist").textContent = title;
            document.getElementById("radio__curr-song").textContent = desc;
            radio.oncanplay = function() {
                document.getElementById("play-pause-btn").classList.remove("loading");
                document.getElementById("play-pause-loading").classList.remove("loading");
            };
        }else{*/
            radio.setAttribute("src", href);
           // document.getElementById("radio__curr-artist").textContent = '';
            document.getElementById("radio__curr-song").textContent = desc;
            document.getElementById("header__info-bar").dataset.channel_id = id;
            radio.oncanplay = function() {
                document.getElementById("play-pause-btn").classList.remove("loading");
                document.getElementById("play-pause-loading").classList.remove("loading");
				document.getElementById("play-pause").setAttributeNS("http://www.w3.org/1999/xlink", 'xlink:href', '#play-active');
                radio.play().then(function (_) {
                }).catch(function (error) {
                    console.log(error);
                });

                return ajaxRequestTimer(false);
            };
        //}

        document.getElementById("radio_select").classList.add('close');
        if (window.getComputedStyle(document.getElementById("radio_select")).display === "none") {
            document.getElementById("radio_select").classList.remove('close');
        }

        ajaxRequestTimer();
    });
}

/*=====Alpabet Sort=====*/
var alphabet = {
    wrapper: null,
    init: function () {
        this.createListeners();
        this.wrapper = document.getElementById("alphabet");
    },
    createListeners: function () {
        var wrapper = this;
        document.getElementById("alphabet").addEventListener("click", function(e){
            e.preventDefault();

            if(e.target.nodeName == "A" && e.target.classList.contains("alphabet__item-link")) {
                var id = e.target.innerText;
                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: document.querySelectorAll('[data-letter="'+id+'"]')[0].offsetTop
                });
            }
        });
        if(window.innerWidth < 992) {
            var scrollPos = 0;
            window.addEventListener("scroll", function () {
                var scrollPosition = window.scrollY,
                    height = wrapper.wrapper.clientHeight - window.innerHeight,
                    blockWrapper = document.querySelectorAll(".music__items")[0].clientHeight;

                if(scrollPosition > height){
                    if((blockWrapper - window.innerHeight) < scrollPosition){
                        wrapper.wrapper.style.position = "absolute", wrapper.wrapper.style.top = "auto", wrapper.wrapper.style.bottom = "0",
                            wrapper.wrapper.style.right = "0px";
                    }else{
                        if ((document.body.getBoundingClientRect()).top > scrollPos){
                            wrapper.wrapper.style.position = "fixed", wrapper.wrapper.style.top = "6.5rem", wrapper.wrapper.style.bottom = "auto",
                                wrapper.wrapper.style.right = (document.getElementsByClassName("alphabet__wrapper")[0].getBoundingClientRect().left - 15)+"px";
                        }else {
                            wrapper.wrapper.style.position = "fixed", wrapper.wrapper.style.top = "-"+(height + 50)+"px", wrapper.wrapper.style.bottom = "auto",
                                wrapper.wrapper.style.right = (document.getElementsByClassName("alphabet__wrapper")[0].getBoundingClientRect().left - 15)+"px";
                        }
                    }
                    scrollPos = (document.body.getBoundingClientRect()).top;
                }else{
                    wrapper.wrapper.style.position = "absolute", wrapper.wrapper.style.top = "0", wrapper.wrapper.style.bottom = "auto";
                    wrapper.wrapper.style.right = "0px";
                }
            });
        }else{
            window.addEventListener("scroll", function () {
                if(document.getElementById("alphabet")) {
                    var scrollPosition = window.scrollY,
                        element = document.getElementById("alphabet"),
                        header = document.getElementById("header"),
                        topPosition = element.offsetTop;

                    if (scrollPosition > topPosition) {
                        element.parentElement.classList.add("fixed");
                        if ((document.body.getBoundingClientRect()).top > scrollPos) {
                            element.parentElement.classList.top = header.clientHeight + "px";
                        } else {
                            element.parentElement.style.top = header.clientHeight + "px";
                        }
                        scrollPos = (document.body.getBoundingClientRect()).top;
                    } else {
                        element.parentElement.classList.remove("fixed");
                    }
                }
            });
        }
    }
}

if(document.getElementById("alphabet")) {
    alphabet.init();
}

/*===========Form=========*/
function form_submit() {
    if (document.getElementById("form__submit")) {
        document.getElementById("form__submit").addEventListener("click", function (e) {
            document.getElementById("alert").classList.remove("open");
            document.getElementById("alert-type").innerHTML = "";
            document.getElementById("alert-head").innerHTML = "УСПЕШНО";
            document.getElementById("alert").classList.remove("error");
            document.getElementById("fountainG").classList.add("active");
            document.getElementById("form__submit-text").classList.add("hidden");

            var formData = new FormData(),
                form = this.closest("form").elements,
                url = this.closest("form").getAttribute("action"),
                http = new XMLHttpRequest(),
                error = new Map(),
                formError = this.dataset.error;

            for (var i = 0; i < form.length; i++) {
                if(form[i].type == "file"){
                    formData.append(form[i].name, form[i].files[0]);
                }else if(form[i].type == "checkbox") {
                    if(form[i].checked){
                        formData.append(form[i].name, form[i].value);
                    }else{
                        error.set('error', 0);
                    }
                }else if(form[i].hasAttribute("required", "required") && form[i].value == ""){
                    error.set('error', 0);
                }else{
                    formData.append(form[i].name, form[i].value);
                }
            }

            if(error.size > 0){
                document.getElementById("alert-type").innerHTML = "!";
                document.getElementById("alert-head").innerHTML = formError;
                document.getElementById("alert").classList.add("error");
                document.getElementById("alert").classList.add("open");
                closetimeAlert();
                document.getElementById("fountainG").classList.remove("active");
                document.getElementById("form__submit-text").classList.remove("hidden");
            }else {
                http.open('POST', url, true);
                http.onreadystatechange = function () {
                    if (http.readyState == 4 && http.status == 200) {
                        var data = JSON.parse(http.response);
                        if (data.status == true) {
                            for (var i = 0; i < form.length; i++) {
                                if(form[i].type !== 'checkbox' && form[i].name !== 'title'){
                                    form[i].value = "";
                                }

                                if (form[i].previousElementSibling !== null && form[i].previousElementSibling !== undefined && form[i].previousElementSibling.nodeName == "LABEL") {
                                    form[i].previousElementSibling.classList.remove("active");
                                }
                            }

                            document.getElementById("alert-head").innerHTML = data.message;
                            document.getElementById("alert").classList.add("open");
                            closetimeAlert();

                            document.getElementById("fountainG").classList.remove("active");
                            document.getElementById("form__submit-text").classList.remove("hidden");
                        } else if (http.status == 419) {
                            var error = document.createElement("div"),
                                text = document.createElement("p"),
                                data = JSON.parse(http.response);

                            error.className = "error__alert", text.className = "error__alert-text", text.textContent = data.error;
                            error.appendChild(text);
                            document.getElementById("error").innerHTML = error;
                            document.getElementById("fountainG").classList.remove("active");
                            document.getElementById("form__submit-text").classList.remove("hidden");
                        }
                    }
                }
                http.send(formData);
            }
        });
    }
}

function inputs() {
    var inputs = document.getElementsByClassName("form__input"),
        inputsFile = document.getElementsByClassName("form__file-input")[0];

    if(inputsFile) {
        inputsFile.addEventListener("change", function () {
            this.nextElementSibling.textContent = this.files[0].name;
        });
    }

    for (var i = 0; i < inputs.length; i++) {
        if(inputs[i].closest(".form__input-hidden")) inputs[i].closest(".form__input-hidden").style.display = 'none';
        inputs[i].addEventListener("click", function () {
            labelSize(this);
        });
        inputs[i].addEventListener("focusout", function () {
            labelSize(this);
        });
    }
}

function labelSize(element){
    var labels = element.parentElement;
    if(element.value || element === document.activeElement){
        labels.children[0].classList.add("active");
    }else{
        labels.children[0].classList.remove("active");
    }
}

if(document.getElementsByClassName("form__input")[0]){
    inputs();
}

form_submit();

/*======AJAX LINK========*/
function ajaxSendRequest(preLoader,http,history,container, url){
    preLoader.classList.remove("active");
    container.innerHTML = http.response;
    if(document.getElementById("dataPickerPagination")) {
        calendar.init({
            pagination: document.getElementById("dataPickerPagination")
        });
    }
    if(document.getElementById("banners__slider")) {
        var slideSpeed = document.querySelectorAll('[data-frametime]')[0].dataset.frametime;
        if(slideSpeed > 0) {
            var slider = tns({
                container: '#banners__slider',
                items: 1,
                autoplay: true,
                autoplayTimeout: slideSpeed,
                controls: true,
                controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" width="28.844" height="45.989" viewBox="0 0 28.844 45.989"> <path id="arrow-left" d="M2231.941,377.874l-24.027,20.177,24.027,20.177" transform="translate(-2205.914 -375.056)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/> </svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="28.844" height="45.989" viewBox="0 0 28.844 45.989"><path id="arrow-left" d="M2207.914,377.874l24.027,20.177-24.027,20.177" transform="translate(-2205.096 -375.056)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/> </svg>'],
                nav: true,
                navPosition: "bottom"
            });
        }else{
            var slider = tns({
                container: '#banners__slider',
                items: 1,
                autoplay: false,
                controls: true,
                controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" width="28.844" height="45.989" viewBox="0 0 28.844 45.989"> <path id="arrow-left" d="M2231.941,377.874l-24.027,20.177,24.027,20.177" transform="translate(-2205.914 -375.056)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/> </svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="28.844" height="45.989" viewBox="0 0 28.844 45.989"><path id="arrow-left" d="M2207.914,377.874l24.027,20.177-24.027,20.177" transform="translate(-2205.096 -375.056)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/> </svg>'],
                nav: true,
                navPosition: "bottom"
            });
        }
    }
    if(document.getElementById("alphabet")){
        alphabet.init();
    }
    if(document.getElementsByClassName("form__input")[0]) inputs();
    if(document.getElementById("page__title-data") !== null){
        document.getElementById("page__title").textContent = document.getElementById("page__title-data").dataset.pageTitle;
        document.getElementById("head-title").textContent = document.getElementById("page__title-data").dataset.pageTitle;
    }

    if(history){
        window.history.pushState( {url:url} , document.getElementById("page__title-data"), url );
    }
    if(document.getElementsByClassName("form__input")[0]){
        inputs();
    }
    if(document.getElementById("conditats__link")) {
        var condidat = document.getElementById("conditats__link");
        condidat.addEventListener("click", function(e){
            e.preventDefault();
            condidat.classList.toggle('open');
            document.getElementById("condidates").classList.toggle('open');
        });
    }
    form_submit();
    search();
    imageLazyLoad();
    window.scroll({behavior: 'smooth',left: 0,top: 0});
    if(window.innerWidth > 992) {
        headerScroll();
    }

    video.init({
        ajax: true
    });
}

function ajax(url,preLoader,container,history,ajaxCount){
    var http = new XMLHttpRequest(),
        ajaxCount = (ajaxCount == undefined)? 0: ajaxCount;

    var sendUrl = (url.includes("?"))? url+"&ajax=1": url+"?ajax=1";
    sendUrl = (window.innerWidth < 993)? sendUrl+'&platform=m':sendUrl+'&platform=d';

    http.open('GET', sendUrl, true);
    http.onreadystatechange = function () {
        if (http.readyState == 4 && http.status == 200) {
            ajaxSendRequest(preLoader,http,history,container,url);
            var lang = document.getElementById("language"),
                href = (window.location.href),
                href = (href.includes("/ru/"))? href.replace("/ru/", "/ro/"): href.replace("/ro/", "/ru/"),
                langRo = (href.includes("/ru/"))? href.replace("/ru/", "/ro/"): href,
                langRu = (href.includes("/o/"))? href.replace("/ro/", "/ru/"): href;
            lang.setAttribute("href", href);
            if(document.getElementById("language-ro")) document.getElementById("language-ro").setAttribute("href", langRo);
            if(document.getElementById("language-ru")) document.getElementById("language-ru").setAttribute("href", langRu);
        }else if(http.status === 500 || http.status === 404){
            if(ajaxCount < 1){
                ajax(url,preLoader,container,history,ajaxCount + 1);
            }else{
                ajaxSendRequest(preLoader,http,history,container,url);
            }
        }
    }
    http.send();
}
/*====== Live Click===========*/
function live (eventType, elementQuerySelector, cb) {
    document.addEventListener(eventType, function (event) {
        var qs = document.querySelectorAll(elementQuerySelector);
        if (qs) {
            var el = event.target, index = -1;
            while (el && ((index = Array.prototype.indexOf.call(qs, el)) === -1)) {
                el = el.parentElement;
            }

            if (index > -1) {
                cb.call(el, event);
            }
        }
    });
}

live('click', '.ajax__link', function(event) {
    event.preventDefault();
    var container = document.getElementById("ajax__container"),
        preLoader = document.getElementById("ajax__preloader"),
        burger = document.getElementById("mob-hamburger").children[0];

    if(burger.classList.contains("is-active")){
        burger.parentElement.nextElementSibling.classList.remove("open");
        burger.classList.remove("is-active");
    }

    preLoader.classList.add("active");
    container.innerHTML = "";
    ajax(this.getAttribute("href"),preLoader,container, true);
    Object.values(document.getElementsByClassName("ajax__link")).forEach(function(item){
        item.classList.remove("active");
    });
    event.target.classList.add("active");
});

live('click', '.back__link', function(event) {
    event.preventDefault();
    var container = document.getElementById("ajax__container"),
        preLoader = document.getElementById("ajax__preloader"),
        burger = document.getElementById("mob-hamburger").children[0];

    if(burger.classList.contains("is-active")){
        burger.parentElement.nextElementSibling.classList.remove("open");
        burger.classList.remove("is-active");
    }

    preLoader.classList.add("active");
    container.innerHTML = "";
    ajax(e.state.url,preLoader,container, false);
});

live('click', '.hit__item-vote-svg', function(event) {
    event.preventDefault();
    var http = new XMLHttpRequest(),
        url = event.target.parentElement.dataset.content;
    http.open('GET', url, true);
    http.onreadystatechange = function () {
        if (http.readyState == 4 && http.status == 200) {
            var messages = document.getElementById('vote-messages'),
                result = http.response;
            if (result == 3) {
                event.target.classList.remove("unactive");
                event.target.childNodes[0].setAttributeNS("http://www.w3.org/1999/xlink", 'xlink:href', '#heart-active');
                document.getElementById("alert-head").innerHTML = messages.dataset.message1;
                document.getElementById("alert").classList.add("open");
            }else if(result == 2){
                event.target.classList.remove("unactive");
                event.target.childNodes[0].setAttributeNS("http://www.w3.org/1999/xlink", 'xlink:href', '#heart-active');
                document.getElementById("alert-head").innerHTML = messages.dataset.message2;
                document.getElementById("alert").classList.add("open");
            }else if(result == 1){
                event.target.classList.remove("unactive");
                event.target.childNodes[0].setAttributeNS("http://www.w3.org/1999/xlink", 'xlink:href', '#heart-active');
                document.getElementById("alert-head").innerHTML = messages.dataset.message3;
                document.getElementById("alert").classList.add("open");
            }else{
                document.getElementById("alert-head").innerHTML = messages.dataset.message4;
                document.getElementById("alert-type").innerHTML = "!";
                document.getElementById("alert").classList.add("error");
                document.getElementById("alert").classList.add("open");
            }

            closetimeAlert();
        }
    }
    http.send();
});

live('click', '.form__alert-close', function(event) {
    event.preventDefault();
    document.getElementById("alert").classList.remove("open");
});

function closetimeAlert(){
    if(window.timerMessage !== undefined) window.clearInterval(window.timerMessage);
    window.timerMessage = setTimeout(function () {
        document.getElementById("alert").classList.remove("open");
        document.getElementById("alert-type").innerHTML = "";
        document.getElementById("alert-head").innerHTML = "УСПЕШНО";
        document.getElementById("alert").classList.remove("error");
    }, 10000);
}

window.onpopstate = function(e){
    var container = document.getElementById("ajax__container"),
        preLoader = document.getElementById("ajax__preloader"),
        burger = document.getElementById("mob-hamburger").children[0];

    if(burger.classList.contains("is-active")){
        burger.parentElement.nextElementSibling.classList.remove("open");
        burger.classList.remove("is-active");
    }

    preLoader.classList.add("active");
    container.innerHTML = "";

    ajax(e.state.url,preLoader,container, false);
};

(function() {
    'use strict';
    function trackScroll() {
        var scrolled = window.pageYOffset;
        var coords = document.documentElement.clientHeight;

        if (scrolled > coords) {
            goTopBtn.classList.add('back_to_top-show');
        }
        if (scrolled < coords) {
            goTopBtn.classList.remove('back_to_top-show');
        }
    }

    function backToTop() {
        if (window.pageYOffset > 0) {
            window.scrollBy(0, -80);
            setTimeout(backToTop, 0);
        }
    }

    var goTopBtn = document.querySelector('.back_to_top');

    window.addEventListener('scroll', trackScroll);
    goTopBtn.addEventListener('click', backToTop);

    window.history.pushState( {url:window.location.href} , document.getElementById("page__title-data"), window.location.href );
})();

var domIsReady = (function(domIsReady) {
    var isBrowserIeOrNot = function() {
        return (!document.attachEvent || typeof document.attachEvent === "undefined" ? 'not-ie' : 'ie');
    }

    domIsReady = function(callback) {
        if(callback && typeof callback === 'function'){
            if(isBrowserIeOrNot() !== 'ie') {
                document.addEventListener("DOMContentLoaded", function() {
                    return callback();
                });
            } else {
                document.attachEvent("onreadystatechange", function() {
                    if(document.readyState === "complete") {
                        return callback();
                    }
                });
            }
        } else {
            console.error('The callback is not a function!');
        }
    }

    return domIsReady;
})(domIsReady || {});

(function(document, window, domIsReady, undefined) {
    domIsReady(function() {
        document.getElementById("header__info-bar").style.display = "flex";
        if(document.getElementById("banners__slider")) {
            var slideSpeed = document.querySelectorAll('[data-frametime]')[0].dataset.frametime;
            if(slideSpeed > 0) {
                var slider = tns({
                    container: '#banners__slider',
                    items: 1,
                    autoplay: true,
                    autoplayTimeout: slideSpeed,
                    controls: true,
                    controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" width="28.844" height="45.989" viewBox="0 0 28.844 45.989"> <path id="arrow-left" d="M2231.941,377.874l-24.027,20.177,24.027,20.177" transform="translate(-2205.914 -375.056)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/> </svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="28.844" height="45.989" viewBox="0 0 28.844 45.989"><path id="arrow-left" d="M2207.914,377.874l24.027,20.177-24.027,20.177" transform="translate(-2205.096 -375.056)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/> </svg>'],
                    nav: true,
                    navPosition: "bottom"
                });
            }else{
                var slider = tns({
                    container: '#banners__slider',
                    items: 1,
                    autoplay: false,
                    controls: true,
                    controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" width="28.844" height="45.989" viewBox="0 0 28.844 45.989"> <path id="arrow-left" d="M2231.941,377.874l-24.027,20.177,24.027,20.177" transform="translate(-2205.914 -375.056)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/> </svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="28.844" height="45.989" viewBox="0 0 28.844 45.989"><path id="arrow-left" d="M2207.914,377.874l24.027,20.177-24.027,20.177" transform="translate(-2205.096 -375.056)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/> </svg>'],
                    nav: true,
                    navPosition: "bottom"
                });
            }
        }
        imageLazyLoad();
    });
})(document, window, domIsReady);